import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';

// --- Components & Styles ---
import "../Styles/CustomerEdit.css"; // Using a dedicated stylesheet
const API_URL = process.env.REACT_APP_API_URL;
const CustomerEdit = () => {
    const { customercode } = useParams();
    const [form, setForm] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    
    // BUG FIX: Add auth token to all API calls
    const token = localStorage.getItem("token");
    const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

    useEffect(() => {
        if (!token) {
            navigate("/login");
            return;
        }
        // BUG FIX: Added 'headers'
        axios.get(`${API_URL}/customers/${customercode}`, { headers })
            .then(res => setForm(res.data))
            .catch((err) => {
                if(err.response?.status === 401) navigate("/login");
                else toast.error("Failed to fetch customer data.");
            })
            .finally(() => setLoading(false));
    }, [customercode, headers, navigate, token]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // BUG FIX: Added 'headers'
            await axios.put(`${API_URL}/customers/${customercode}`, form, { headers });
            toast.success("Customer updated successfully");
            navigate("/masters/customers");
        } catch {
            toast.error("Failed to update customer");
        }
    };

    if (loading || !form) {
        return <p style={{ textAlign: "center", padding: "2rem" }}>Loading...</p>;
    }

    return (
        <>
            <div className="form-container">
                <form onSubmit={handleSubmit} className="customer-edit-form">
                    <div className="form-group"><label htmlFor="customername">Customer Name*</label><input id="customername" name="customername" value={form.customername || ""} onChange={handleChange} required /></div>
                    <div className="form-group"><label htmlFor="mobile">Mobile</label><input id="mobile" name="mobile" value={form.mobile || ""} onChange={handleChange} /></div>
                    <div className="form-group"><label htmlFor="email">Email</label><input id="email" name="email" type="email" value={form.email || ""} onChange={handleChange} /></div>
                    <div className="form-group"><label htmlFor="tinno">GST Number</label><input id="tinno" name="tinno" value={form.tinno || ""} onChange={handleChange} /></div>
                    <div className="form-group"><label htmlFor="address1">Address Line 1</label><input id="address1" name="address1" value={form.address1 || ""} onChange={handleChange} /></div>
                    <div className="form-group"><label htmlFor="address2">Address Line 2</label><input id="address2" name="address2" value={form.address2 || ""} onChange={handleChange} /></div>
                    <div className="form-group"><label htmlFor="city">City</label><input id="city" name="city" value={form.city || ""} onChange={handleChange} /></div>
                    <div className="form-group"><label htmlFor="state">State</label><input id="state" name="state" value={form.state || ""} onChange={handleChange} /></div>
                    <div className="form-group"><label htmlFor="pincode">Pincode</label><input id="pincode" name="pincode" value={form.pincode || ""} onChange={handleChange} /></div>
                    
                    <div className="form-actions">
                        <button type="button" className="btn btn-outline" onClick={() => navigate(-1)}>Cancel</button>
                        <button type="submit" className="btn btn-primary">Save Changes</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default CustomerEdit;